// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CompassOutlinedSvg from "@ant-design/icons-svg/es/asn/CompassOutlined";
import AntdIcon from '../components/AntdIcon';

var CompassOutlined = function CompassOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CompassOutlinedSvg
  }));
};

CompassOutlined.displayName = 'CompassOutlined';
export default React.forwardRef(CompassOutlined);